import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { CODEBLOCK_SIZES as t, CODEBLOCK_SIZE_MAP as n } from "./codeblock-constants.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o, toDisplayString as s } from "vue";
//#region components/codeblock/codeblock.vue
var c = {
	compatConfig: { MODE: 3 },
	name: "DtCodeblock",
	props: {
		text: {
			type: String,
			required: !0
		},
		bordered: {
			type: Boolean,
			default: !1
		},
		size: {
			type: [String, Number],
			default: 200,
			validator: (e) => t.includes(String(e))
		}
	},
	computed: { sizeClass() {
		return n[String(this.size)] || String(this.size);
	} }
};
function l(e, t, n, c, l, u) {
	return o(), r("pre", { class: a(["d-codeblock", { "d-codeblock--bordered": n.bordered }]) }, [i("code", { class: a(["d-codeblock__code", `d-codeblock__code--${u.sizeClass}`]) }, s(n.text), 3)], 2);
}
var u = /* @__PURE__ */ e(c, [["render", l]]);
//#endregion
export { u as default };

//# sourceMappingURL=codeblock.js.map